import http from '@/config/http.js';
import store from '@/store/index.js'
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect";
import porvince from "@/assets/json/province.js";
import { isIdCardNo } from "@/libs/checker.js";
import { validateCardId, getBirthdayByIdNO, getSexByIdNO, validateEmail, validatePhone } from "@/libs/elementChecker"

export default function Configs(that) {
    const validateNumber = (rule, value, callback) => {
        var reg = /^[0-9]+(\.[0-9]{0,1})?$/;
        if (value) {
            if (reg.test(value)) {
                callback()
            } else {
                callback(new Error('分数需为数值'));
            }
        } else {
            callback(new Error('请输入分数'));
        }
    }
    // 基础信息
    const formItemsBasic1 = [
        {
            label: "考生号",
            span: 12,
            model: "examNumber",
        },
        {
            label: "姓名",
            span: 12,
            model: "studentName",
        },
        {
            label: "曾用名",
            span: 12,
            model: "usedName",
        },
        {
            label: "身份证号",
            span: 12,
            model: "idCard",
            change(idCardNo) {
                // console.log(idCardNo)
                if (isIdCardNo(idCardNo)) {
                    that.handleData.dateBirth = getBirthdayByIdNO(idCardNo);
                    that.handleData.sex = getSexByIdNO(idCardNo);
                } else {
                    that.handleData.dateBirth = "";
                    that.handleData.sex = "";
                }
            }
        },
        {
            label: "性别",
            span: 12,
            model: "sex",
            type: 'select',
            disabled: true,
            options: dic._SEXS
        },
        {
            label: "出生日期",
            span: 12,
            model: "dateBirth",
            // type: 'date',
            disabled: true,
        },
        {
            label: "民族",
            span: 12,
            model: "nationCode",
            type: "select",
            options: dic._NATION
        },
        {
            label: "籍贯",
            span: 12,
            model: "nativePlace",
        },
        {
            label: "高考成绩",
            span: 12,
            model: "examScore",
        },
        {
            label: "政治面貌",
            span: 12,
            model: "politicalCode",
            type: 'select',
            options: dic._POLITICAL
        },
        {
            label: "入党、团年月",
            span: 12,
            model: "joinPartyTime",
            type: 'month',
        },
        {
            label: "家庭出身",
            span: 12,
            model: "familyBackgroundCode",
            type: 'select',
            options: dic._FAMILYBACKGROUND
        },


    ]
    const formItemsBasic2 = [
        // {
        //     label: "生源地",
        //     span: 12,
        //     type:'select',
        //     model: "studentSourceAreaCode ",
        //     placeholder: '请选择生源地',
        //     options:porvince
        // },
        // {
        //     label: "学生类型",
        //     span: 12,
        //     type:'select',
        //     model: "type ",
        //     placeholder: '请选择学生类型'
        //     options:dic._STUDENT_TYPE
        // },
        {
            label: "健康状况",
            span: 12,
            model: "healthConditionCode",
            type: 'select',
            options: dic._HEALTHCONDITION
        },
        {
            label: "家庭住址",
            span: 12,
            model: "addressAreaCode",
            type: 'cascader',
            options: [],
            props: {
                expandTrigger: 'hover',
                label: 'name',
                value: 'code',
                children: 'sysAreaLists',
                emitPath: false,
            },
        },
        {
            label: "家庭详细住址",
            span: 12,
            model: "addressInfo",
            maxlength: 30,
            showLimit: true,
        },

        {
            label: "家长电话",
            span: 12,
            model: "familyPhone",
        },
        {
            label: "邮编",
            span: 12,
            model: "postcode",
        },
        {
            label: "特长、爱好",
            span: 12,
            model: "hobby",
            maxlength: 30,
            showLimit: true,
        },
        {
            label: "邮箱",
            span: 12,
            model: "email",
            placeholder: '请输入'
        },
        {
            label: "本人电话",
            span: 12,
            model: "phoneNumber",
            placeholder: '请输入联系电话'
        },
        {
            label: "常用QQ",
            span: 12,
            model: "qqCode",
            placeholder: '请输入'
        },

        {
            label: "常用微信",
            span: 12,
            model: "wxCode",
            placeholder: '请输入'
        },
    ]

    const formItemsBasic3 = [
        {
            label: "学号",
            prop: "studentNo",
            span: 8,
            model: "studentNo",
        },
        {
            label: "学院",
            span: 8,
            model: "collegeId",
            type: 'select',
            placeholder: '请选择学院',
            options: dic._COLLEGE_OPTIONS,
            change(data) {
                that.formItems[2].options = [];
                that.formItems[3].options = [];
                that.handleData.majorId = "";
                that.handleData.classId = "";
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, null, 1);
                }
            },
        },

        {
            label: "专业",
            span: 8,
            model: "majorId",
            type: 'select',
            placeholder: '请选择专业',
            options: [],
            change(data) {
                // console.log(data)
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.formItems[3].options = [];
                that.handleData.classId = '';
                if (data) {
                    getOrgOptions(that, params, null, 3)
                }
            },
        },

        {
            label: "班级",
            span: 8,
            model: "classId",
            type: 'select',
            placeholder: '请选择班级',
            options: [],
        },
        {
            label: "年级",
            span: 8,
            type: 'year',
            model: "grade",
        },
        {
            label: "入学年份",
            span: 8,
            type: 'year',
            model: "enrollmentYear",
        },
        {
            label: "毕业年份",
            span: 8,
            type: 'year',
            model: "graduateYear",
        },
        {
            label: "学籍状态",
            span: 8,
            type: 'select',
            options: dic._STUDENTSTATUS,
            model: "studentStatus",
        },
        {
            label: "学制",
            span: 8,
            model: "academicYear",
            placeholder: '请选择学制',
            type: 'select',
            options: dic._ACADEMICYEAR
        },
        {
            label: "培养层次",
            span: 8,
            model: "academicDegree",
            type: 'select',
            options: dic._ACADEMICDEGREE
        },
    ]
    const formItemsBasic4 = [
        {
            label: "贷款金额",
            span: 8,
            model: "loanAmount",
        },

    ]

    const formRules = {
        idCard: [{
            required: true,
            validator: validateCardId,
            trigger: "blur"
        }],
        enrollmentYear: [{
            required: true,
            trigger: "blur",
            message: '请选择入学年份',
        }],
        graduateYear: [{
            required: true,
            trigger: "blur",
            message: '请选择毕业年份',
        }],
        studentName: [{
            required: true,
            trigger: "blur",
            message: '请输入姓名',
        }],
        // studentId: [{
        //     required: true,
        //     trigger: "blur",
        //     message: '请输入编号',
        // }],
        studentNo: [{
            required: true,
            trigger: "blur",
            message: '请输入学号',
        }],
        // bankCard: [{
        //     required: true,
        //     trigger: "blur",
        //     message: '请输入银行卡号',
        // }],
        examNumber: [{
            required: true,
            trigger: "blur",
            message: '请输入考生号',
        }],
        // graduateSchool: [{
        //     required: true,
        //     trigger: "blur",
        //     message: '请输入毕业学校',
        // }],
        collegeId: [{
            required: true,
            trigger: "change",
            message: '请选择学院',
        }],
        grade: [{
            required: true,
            trigger: "change",
            message: '请选择年级',
        }],
        majorId: [{
            required: true,
            trigger: "change",
            message: '请选择专业',
        }],
        classId: [{
            required: true,
            trigger: "change",
            message: '请选择班级',
        }],
        academicYear: [{
            required: true,
            trigger: "blur",
            message: '请选择学制',
        }],
        academicDegree: [{
            required: true,
            trigger: "change",
            message: '请选择培养层次',
        }],
        // joinPartyTime: [
        //     {
        //         required: true,
        //         message: '请选择入党、团年月',
        //         trigger: "blur"
        //     }
        // ],
        familyBackground: [
            {
                required: true,
                message: '请选择',
                trigger: "blur"
            }
        ],
        familyBackgroundCode: [
            {
                required: true,
                message: '请选择家庭出身',
                trigger: "blur"
            }
        ],
        healthCondition: [
            {
                required: true,
                message: '请选择',
                trigger: "blur"
            }
        ],
        healthConditionCode: [
            {
                required: true,
                message: '请选择健康状况',
                trigger: "blur"
            }
        ],
        addressAreaCode: [
            {
                required: true,
                message: '请选择家庭住址地区',
                trigger: "blur"
            }
        ],
        nationCode: [
            {
                required: true,
                message: '请选择民族',
                trigger: "change"
            }
        ],
        politicalCode: [
            {
                required: true,
                message: '请选择政治面貌',
                trigger: "change"
            }
        ],
        nativePlace: [
            {
                required: true,
                message: '请输入籍贯',
                trigger: "blur"
            }
        ],
        examScore: [
            {
                required: true,
                // message: '请输入',
                trigger: "blur",
                validator: validateNumber
            },
        ],
        addressInfo: [
            {
                required: true,
                message: '请输入家庭详细住址',
                trigger: "blur"
            }
        ],
        familyPhone: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
        }],
        postcode: [
            {
                required: true,
                message: '请输入邮编',
                trigger: "blur"
            }
        ],
        hobby: [
            {
                required: true,
                message: '请输入特长、爱好',
                trigger: "blur"
            }
        ],
        phoneNumber: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
        }],
        email: [{
            required: true,
            validator: validateEmail,
            trigger: "blur"
        }],
        photoUrl: [
            {
                required: true,
                message: '请上传图片',
                trigger: "change"
            }
        ],
        studentStatus: [
            {
                required: true,
                message: '请选择学籍状态',
                trigger: "change"
            }
        ],
    }
    return {
        formItemsBasic1,
        formItemsBasic2,
        formItemsBasic3,
        formItemsBasic4,
        formRules,
    }
}
